import { CalendarService } from 'src/app/services/calendar/calendar.service';
import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';

// Calendar option
import { CalendarOptions, EventClickArg, EventApi, FullCalendarComponent } from '@fullcalendar/angular';
// BootStrap
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
// Sweet Alert
import Swal from 'sweetalert2';

import { category, calendarEvents, createEventId } from './data';
import { ActivatedRoute } from '@angular/router';
import * as dayjs from 'dayjs';
import { BlackoutdayService } from 'src/app/services/blackoutday/blackoutday.service';
import { CampaignService } from 'src/app/services/campaigns/campaign.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
	selector: 'app-calendar',
	templateUrl: './calendar.component.html',
	styleUrls: ['./calendar.component.scss'],
})

/**
 * Calendar Component
 */
export class CalendarComponent implements OnInit {
	// bread crumb items
	breadCrumbItems!: Array<{}>;

	// calendar
	calendarEvents!: any[];
	editEvent: any;
	formEditData!: FormGroup;
	newEventDate: any;
	category!: any[];
	submitted = false;
	campaignInfo: any;

	// Calendar click Event
	formData!: FormGroup;
	@ViewChild('editmodalShow') editmodalShow!: TemplateRef<any>;
	@ViewChild('modalShow') modalShow!: TemplateRef<any>;
	@ViewChild('calendar') calendarComponent!: FullCalendarComponent;

	campaign_id: number;
	alias: number;
	campaign_name: string;

	constructor(private modalService: NgbModal, private formBuilder: FormBuilder, private route: ActivatedRoute, private calendarSrv: CalendarService, private bodSrv: BlackoutdayService, private campaignSrv: CampaignService, private sanitizer: DomSanitizer,) {
		this.campaign_id = parseInt(this.route.snapshot.paramMap.get('campaign_id'));
		this.alias = parseInt(this.route.snapshot.paramMap.get('alias'));
	}

	ngOnInit(): void {
		/**
		 * BreadCrumb
		 */

		this.breadCrumbItems = [{ label: 'Apps' }, { label: 'Calendar', active: true }];

		// Validation
		this.formData = this.formBuilder.group({
			title: ['', [Validators.required]],
			category: ['', [Validators.required]],
		});

		// this._fetchData();
		this.getMonthLeads();
		this.getInfoCalendar();
	}

	/**
	 * Fetches the data
	 */
	private _fetchData() {
		// Event category
		// this.category = category;
		// Calender Event Data
		// this.calendarEvents = calendarEvents;
	}

	/***
	 * Calender Set
	 */
	calendarOptions: CalendarOptions = {
		headerToolbar: {
			left: 'dayGridMonth,dayGridWeek,dayGridDay',
			center: 'title',
			right: 'prev,today,next',
		},
		initialView: 'dayGridMonth',
		initialEvents: this.calendarEvents,
		weekends: true,
		editable: false,
		selectable: true,
		selectMirror: true,
		dayMaxEvents: true,
		dateClick: this.handleDateClick.bind(this),
		eventClick: this.handleEventClick.bind(this),
		eventsSet: this.handleEvents.bind(this),
	};
	currentEvents: EventApi[] = [];

	/**
	 * Event add modal
	 */
	openModal(event?: any) {
		this.newEventDate = event;
		this.modalService.open(this.modalShow, { centered: true });
	}

	changeToDayView(date) {
		const selectedDate = dayjs(date).toDate();
		this.calendarComponent.getApi().gotoDate(selectedDate);
		this.calendarComponent.getApi().changeView('dayGridDay');
	}

	openLead(lead_id) {
		window.open(`https://admin.lmsleads.com/#/lead-edit/${lead_id}`, '_blank');
	}

	/**
	 * Event click modal show
	 */
	handleEventClick(clickInfo: any) {
		const lead_id = clickInfo.event.extendedProps.metadata.lead_id;
		this.openLead(lead_id);
	}

	handleDateClick(clickInfo: any) {
		this.changeToDayView(clickInfo.dateStr);
	}

	/**
	 * Events bind in calander
	 * @param events events
	 */
	handleEvents(events: EventApi[]) {
		this.currentEvents = events;
	}

	/**
	 * Close event modal
	 */
	closeEventModal() {
		this.formData = this.formBuilder.group({
			title: '',
			category: '',
		});
		this.modalService.dismissAll();
	}

	/***
	 * Model Position Set
	 */
	position() {
		Swal.fire({
			position: 'center',
			icon: 'success',
			title: 'Event has been saved',
			showConfirmButton: false,
			timer: 1000,
		});
	}

	/***
	 * Model Edit Position Set
	 */
	Editposition() {
		Swal.fire({
			position: 'center',
			icon: 'success',
			title: 'Event has been Updated',
			showConfirmButton: false,
			timer: 1000,
		});
	}

	/**
	 * Event Data Get
	 */
	get form() {
		return this.formData.controls;
	}

	/**
	 * Save the event
	 */
	saveEvent() {
		if (this.formData.valid) {
			const title = this.formData.get('title')!.value;
			const className = this.formData.get('category')!.value;
			const calendarApi = this.newEventDate.view.calendar;
			calendarApi.addEvent({
				id: createEventId(),
				title,
				start: this.newEventDate.date,
				end: this.newEventDate.date,
				className: className + ' ' + 'text-white',
			});
			this.position();
			this.formData = this.formBuilder.group({
				title: '',
				category: '',
			});
			this.modalService.dismissAll();
		}
		this.submitted = true;
	}

	/**
	 * save edit event data
	 */
	editEventSave() {
		const editTitle = this.formEditData.get('editTitle')!.value;
		const editCategory = this.formEditData.get('editCategory')!.value;

		const editId = this.calendarEvents.findIndex((x) => x.id + '' === this.editEvent.id + '');

		this.editEvent.setProp('title', editTitle);
		this.editEvent.setProp('classNames', editCategory);

		this.calendarEvents[editId] = {
			...this.editEvent,
			title: editTitle,
			id: this.editEvent.id,
			classNames: editCategory,
		};
		this.Editposition();
		this.formEditData = this.formBuilder.group({
			editTitle: '',
			editCategory: '',
		});
		this.modalService.dismissAll();
	}

	/**
	 * Delete-confirm
	 */
	confirm() {
		Swal.fire({
			title: 'Are you sure?',
			text: "You won't be able to revert this!",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#34c38f',
			cancelButtonColor: '#f46a6a',
			confirmButtonText: 'Yes, delete it!',
		}).then((result) => {
			if (result.value) {
				this.deleteEventData();
				Swal.fire('Deleted!', 'Event has been deleted.', 'success');
			}
		});
	}

	/**
	 * Delete event
	 */
	deleteEventData() {
		this.editEvent.remove();
		this.modalService.dismissAll();
	}

	getMonthLeads() {
		const payload = {
			campaign_id: this.campaign_id,
			current_date: dayjs().format('YYYY-01-DD'),
		};
		this.calendarSrv.getCampaignMonthLeads(payload).subscribe((res: any) => {
			this.calendarEvents = this.transformLeadsToEvents(res.body.res);
			this.campaign_name = res.body.campaign_name;
			this.getBlackOutDays(this.campaign_id);
		});
	}

	transformLeadsToEvents(leads: any[]): any[] {
		return leads.map((lead) => ({
			id: createEventId(),
			title: lead.prospect_name,
			start: dayjs(`${lead.start_date} ${lead.start_time}`).toDate(),
			end: dayjs(`${lead.end_date} ${lead.end_time}`).toDate(),
			allDay: false,
			className: lead.status === 1 ? 'bg-soft-primary' : 'bg-soft-success',
			metadata: { lead_id: lead.lead_id },
		}));
	}

	getBlackOutDays(campaign_id: number) {
		this.bodSrv.getCampaignBlackOutDays(campaign_id).subscribe((data: any) => {
			let bods = data.body;

			bods = bods.map((bod) => ({
				id: createEventId(),
				title: `${dayjs(bod.initial_date_hour, 'YYYY-MM-DD HH:mm:ss').format('h:mm A')} - ${dayjs(bod.end_date_hour, 'YYYY-MM-DD HH:mm:ss').format('h:mm A')}`,
				start: new Date(bod.initial_date_hour),
				end: new Date(bod.end_date_hour),
				allDay: false,
				className: 'bg-soft-danger',
				metadata: { bod: true, name: 'Black Out Day' },
			}));

			this.calendarEvents = this.calendarEvents.concat(bods);
			this.calendarOptions = { ...this.calendarOptions, events: this.calendarEvents };
			this.calendarComponent.getApi().refetchEvents(); // Refresca los eventos
			this.calendarComponent.getApi().render();
		});

		// this.dataService.post(url, { alias: campaignAlias }).then((data) => {
		// 	let eventos = [];
		// 	data.records.forEach((bod) => {
		// 		let evento = {
		// 			start: new Date(bod.initial_date_hour),
		// 			end: new Date(bod.end_date_hour),
		// 			title: 'Black Out Day',
		// 			color: colors.red,
		// 			actions: this.actions,
		// 			allDay: false,
		// 			meta: {
		// 				bod: true,
		// 				name: 'Black Out Day',
		// 			},
		// 		};

		// 		eventos.push(evento);
		// 	});

		// 	this.events = this.events.concat(eventos);
		// });
	}

	getInfoCalendar() {

		this.campaignSrv.getCampaignInfoCalendar(this.campaign_id).subscribe((data: any) => {
			this.campaignInfo = data.body;
			this.campaignInfo.script = this.sanitizer.bypassSecurityTrustHtml(this.campaignInfo.script);
			this.campaignInfo.who_we_are = this.sanitizer.bypassSecurityTrustHtml(this.campaignInfo.who_we_are);
			this.campaignInfo.what_we_do = this.sanitizer.bypassSecurityTrustHtml(this.campaignInfo.what_we_do);
			this.campaignInfo.why_us = this.sanitizer.bypassSecurityTrustHtml(this.campaignInfo.why_us);
		});
	}
}
